import { render, staticRenderFns } from "./yachChat.vue?vue&type=template&id=38a20c56"
import script from "./yachChat.vue?vue&type=script&lang=ts"
export * from "./yachChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports